/**
 * Admin Routes Configuration
 *
 * Configuração das rotas do painel administrativo
 */
import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import {
	AdminLayout,
	LoginScreen,
	DashboardScreen,
	UsersScreen,
	UserDetailScreen,
	ClubsScreen,
	ClubDetailScreen,
	MatchesScreen,
	MatchDetailScreen,
	FeedbacksScreen,
	RatingsScreen,
	InvitationsScreen,
	BroadcastScreen,
	LogsScreen,
} from '../components/screens'
import { useAdminStore } from '../core/admin.store'

// Componente para rotas protegidas
function PrivateRoute({ children }) {
	const { isAuthenticated, isReady, admin, initializeAuth } = useAdminStore()

	// Inicializa auth se ainda não estiver pronto
	React.useEffect(() => {
		if (!isReady) {
			initializeAuth()
		}
	}, [isReady, initializeAuth])

	// Mostra loading enquanto verifica
	if (!isReady) {
		return (
			<div style={{ 
				display: 'flex', 
				justifyContent: 'center', 
				alignItems: 'center', 
				height: '100vh',
				background: '#1a1a2e'
			}}>
				<div style={{ color: '#fff' }}>Carregando...</div>
			</div>
		)
	}

	if (!isAuthenticated || !admin) {
		return <Navigate to="/admin/login" replace />
	}

	// Verificar se é admin ou superadmin
	if (admin.role !== 'admin' && admin.role !== 'superadmin') {
		return <Navigate to="/admin/login" replace />
	}

	return children
}

// Componente para rota de login (redireciona se já logado)
function PublicRoute({ children }) {
	const { isAuthenticated, isReady, admin, initializeAuth } = useAdminStore()

	// Inicializa auth se ainda não estiver pronto
	React.useEffect(() => {
		if (!isReady) {
			initializeAuth()
		}
	}, [isReady, initializeAuth])

	// Mostra loading enquanto verifica
	if (!isReady) {
		return (
			<div style={{ 
				display: 'flex', 
				justifyContent: 'center', 
				alignItems: 'center', 
				height: '100vh',
				background: '#1a1a2e'
			}}>
				<div style={{ color: '#fff' }}>Carregando...</div>
			</div>
		)
	}

	if (isAuthenticated && admin && (admin.role === 'admin' || admin.role === 'superadmin')) {
		return <Navigate to="/admin" replace />
	}

	return children
}

export default function AdminRoutes() {
	return (
		<Routes>
			{/* Login - Rota pública */}
			<Route
				path="login"
				element={
					<PublicRoute>
						<LoginScreen />
					</PublicRoute>
				}
			/>

			{/* Rotas protegidas com Layout */}
			<Route
				path="/*"
				element={
					<PrivateRoute>
						<AdminLayout />
					</PrivateRoute>
				}
			>
				{/* Dashboard */}
				<Route index element={<DashboardScreen />} />

				{/* Users */}
				<Route path="users" element={<UsersScreen />} />
				<Route path="users/:id" element={<UserDetailScreen />} />

				{/* Clubs */}
				<Route path="clubs" element={<ClubsScreen />} />
				<Route path="clubs/:id" element={<ClubDetailScreen />} />

				{/* Matches */}
				<Route path="matches" element={<MatchesScreen />} />
				<Route path="matches/:id" element={<MatchDetailScreen />} />

				{/* Feedbacks */}
				<Route path="feedbacks" element={<FeedbacksScreen />} />

				{/* Ratings */}
				<Route path="ratings" element={<RatingsScreen />} />

				{/* Invitations */}
				<Route path="invitations" element={<InvitationsScreen />} />

				{/* Broadcast */}
				<Route path="broadcast" element={<BroadcastScreen />} />

				{/* Logs */}
				<Route path="logs" element={<LogsScreen />} />

				{/* Fallback */}
				<Route path="*" element={<Navigate to="/admin" replace />} />
			</Route>
		</Routes>
	)
}
